package one.healthium.bland.presentation.navigation.home

import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.webhistory.WebNavigationOwner
import com.arkivanov.decompose.value.Value
import one.healthium.bland.presentation.navigation.today.TodayComponent
import one.healthium.content.navigation.insights.InsightsComponent
import one.healthium.profile.navigation.ProfileMainComponent
import one.healthium.tasks.navigation.DailyTasksComponent
import one.primehealth.app.DeepLink

interface HomeComponent : WebNavigationOwner {
    val stack: Value<ChildStack<*, Child>>

    fun onTodayTabClicked()
    fun onDailyTasksTabClicked()
    fun onInsightsTabClicked()
    suspend fun onChatTabClicked()
    fun onProfileTabClicked()
    fun onDeepLink(deepLink: DeepLink)

    sealed class Child {
        class TodayChild(val component: TodayComponent) : Child()
        class DailyTasksChild(val component: DailyTasksComponent) : Child()
        class InsightsChild(val component: InsightsComponent) : Child()
        data object ChatChild : Child()
        class ProfileChild(val component: ProfileMainComponent) : Child()
    }
}